const LoginAnimation = () => {
  return (
    <div
      className="relative w-full min-h-screen flex flex-col font-museo overflow-hidden"
      style={{
        background: "linear-gradient(157.06deg, #1A0E3E 46.27%, #904DB0 94.25%)",
      }}
    >
      {/* ── Concentric rings — top-left corner ── */}
      <div className="absolute -top-[88px] -left-[88px] pointer-events-none">
        <svg width="350" height="350" viewBox="0 0 350 350" fill="none">
          <circle cx="175" cy="175" r="175" fill="#9C77B4" />
          <circle cx="175" cy="175" r="146" fill="#54BEC3" />
          <circle cx="175" cy="175" r="117" fill="#E99CAB" />
          <circle cx="175" cy="175" r="89"  fill="#534694" />
        </svg>
      </div>

      {/* ── Concentric rings — bottom-right corner ── */}
      <div className="absolute -bottom-[88px] -right-[88px] pointer-events-none">
        <svg width="350" height="350" viewBox="0 0 350 350" fill="none">
          <circle cx="175" cy="175" r="175" fill="#9C77B4" />
          <circle cx="175" cy="175" r="146" fill="#54BEC3" />
          <circle cx="175" cy="175" r="117" fill="#E99CAB" />
          <circle cx="175" cy="175" r="89"  fill="#534694" />
        </svg>
      </div>

      {/* ── Circuit lines — bottom-left ── */}
      <div className="absolute bottom-0 left-0 pointer-events-none" style={{ width: "clamp(300px,55vw,700px)" }}>
        <svg viewBox="0 0 700 400" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto">
          <path d="M380 450V270C380 248 362 230 340 230H60C38 230 20 248 20 270V310" stroke="#E99CAB" strokeWidth="24" strokeLinecap="round"/>
          <path d="M20 302V318C20 356 -10 386 -48 386H-420" stroke="#E99CAB" strokeWidth="24" strokeLinecap="round"/>
          <path d="M404 472V272C404 237 376 208 341 208H62C27 208 -2 237 -2 272V284" stroke="#54BEC3" strokeWidth="24" strokeLinecap="round"/>
          <path d="M-2 276V316C-2 341 -22 361 -47 361H-490" stroke="#54BEC3" strokeWidth="24" strokeLinecap="round"/>
          <path d="M428 492V275C428 224 387 183 336 183H64C13 183 -26 222 -26 273" stroke="#9C77B4" strokeWidth="24" strokeLinecap="round"/>
          <path d="M-26 269V316C-26 327 -35 336 -45 336H-470" stroke="#9C77B4" strokeWidth="24" strokeLinecap="round"/>
        </svg>
      </div>

      {/* ── Circuit lines — top-right ── */}
      <div className="absolute top-0 right-0 pointer-events-none" style={{ width: "clamp(300px,55vw,700px)" }}>
        <svg viewBox="0 0 700 400" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto">
          <path d="M320 -50V170C320 192 338 210 360 210H640C662 210 680 192 680 170V130" stroke="#E99CAB" strokeWidth="24" strokeLinecap="round"/>
          <path d="M680 138V122C680 84 710 54 748 54H1120" stroke="#E99CAB" strokeWidth="24" strokeLinecap="round"/>
          <path d="M296 -72V168C296 203 324 232 359 232H638C673 232 702 203 702 168V156" stroke="#54BEC3" strokeWidth="24" strokeLinecap="round"/>
          <path d="M702 162V122C702 98 722 78 747 78H1144" stroke="#54BEC3" strokeWidth="24" strokeLinecap="round"/>
          <path d="M272 -92V165C272 216 313 257 364 257H637C688 257 727 218 727 167" stroke="#9C77B4" strokeWidth="24" strokeLinecap="round"/>
          <path d="M727 168V121C727 110 736 101 747 101H1117" stroke="#9C77B4" strokeWidth="24" strokeLinecap="round"/>
        </svg>
      </div>

      {/* ── Main centered content ── */}
      <div className="relative z-10 flex flex-col items-center justify-center flex-1 min-h-screen px-6 text-center">

        {/* Headline */}
        <h1
          className="font-museo text-white leading-[1.2] mb-8"
          style={{
            fontSize: "clamp(1.8rem, 4vw, 3.2rem)",
            fontWeight: 300,
            maxWidth: 680,
            textShadow: "0 2px 24px rgba(26,14,62,0.4)",
          }}
        >
          Preparing your
          <br />
          <span style={{ fontWeight: 700 }}>private workspace</span>
        </h1>

        {/* Progress bar */}
        <div
          className="rounded-full overflow-hidden"
          style={{
            width: "clamp(200px, 30vw, 360px)",
            height: 8,
            background: "rgba(255,255,255,0.12)",
          }}
        >
          <div
            className="h-full rounded-full"
            style={{
              background: "linear-gradient(90deg, #C7BFE5, #904DB0, #54BEC3)",
              animation: "linko-progress 2s cubic-bezier(.4,0,.2,1) infinite",
            }}
          />
        </div>

        {/* Dots + label */}
        {/* <div className="flex items-center gap-3 mt-5">
          {[
            { color: "#C7BFE5", delay: "0ms" },
            { color: "#904DB0", delay: "160ms" },
            { color: "#54BEC3", delay: "320ms" },
          ].map(({ color, delay }, i) => (
            <span
              key={i}
              style={{
                display: "inline-block",
                width: 7,
                height: 7,
                borderRadius: "50%",
                background: color,
                animation: `linko-dot-bounce 1.3s ease-in-out infinite ${delay}`,
              }}
            />
          ))}
          <span
            className="font-museo font-semibold tracking-[0.16em] uppercase text-white/60"
            style={{ fontSize: 11, marginLeft: 4 }}
          >
            Loading…
          </span>
        </div> */}

      </div>
    </div>
  );
};

export default LoginAnimation;
